var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaRasenhecke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#7aba5a;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#5cb143;}.cls-6{fill:#384649;}.cls-7{fill:#e8406b;}.cls-8{fill:#e21f56;}.cls-9{fill:#e6e6e6;}.cls-10{mix-blend-mode:color;opacity:0.5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.02,
    y: 8,
    width: 144.28,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.64,107.32V86.46a9,9,0,0,0-9-8.95H64.05a9,9,0,0,0-8.91,8.07"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.1,77.51H74.29a9,9,0,0,0-9,8.95v17.76l-10.2,3.1V86.46a9,9,0,0,1,9-8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.44,102.39a4.44,4.44,0,0,1-4.38-3.78L22.86,22.46,10.5,16.41a4.43,4.43,0,0,1,3.89-8l14.46,7.08a4.42,4.42,0,0,1,2.43,3.33L42.82,97.32a4.43,4.43,0,0,1-3.73,5,4.82,4.82,0,0,1-.65,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M139,97.54,40.46,83.49A15.48,15.48,0,0,0,22.79,98.81v29.68A10.17,10.17,0,0,0,33,138.66H142.12a10.17,10.17,0,0,0,10.18-10.17V112.86A15.48,15.48,0,0,0,139,97.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.3,120.09v8.4a10.17,10.17,0,0,1-10.18,10.17H33a10.17,10.17,0,0,1-10.18-10.17v-8.4A10.17,10.17,0,0,0,33,130.26H142.12a10.17,10.17,0,0,0,10.18-10.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.14,138.66H33a10.17,10.17,0,0,1-10.18-10.17V98.81A15.49,15.49,0,0,1,40.46,83.49l7.83,1.12A15.47,15.47,0,0,0,39,98.81v29.68a10.17,10.17,0,0,0,10.18,10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.32,129.61a22.68,22.68,0,1,1-22.68-22.68,22.67,22.67,0,0,1,22.68,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.29,129.61A13.65,13.65,0,1,1,53.64,116a13.65,13.65,0,0,1,13.65,13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.64,134.34A17.94,17.94,0,1,1,127.7,116.4a17.94,17.94,0,0,1,17.94,17.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.21,134.34a8.51,8.51,0,1,1-8.51-8.5,8.51,8.51,0,0,1,8.51,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.9,108.83H84.46a2.22,2.22,0,1,1,0-4.43H100.9a2.22,2.22,0,0,1,0,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.9,117.19H84.46a2.22,2.22,0,1,1,0-4.43H100.9a2.22,2.22,0,0,1,0,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.9,125.56H84.46a2.22,2.22,0,1,1,0-4.43H100.9a2.22,2.22,0,0,1,0,4.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 160,
    height: 160,
    rx: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaRasenhecke);
export default __webpack_public_path__ + "static/media/ka_rasen+hecke.1d27fdda5060ac61a5ac613a588d8285.svg";
export { ForwardRef as ReactComponent };